import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function AlbumSection() {
    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState([]);
    const [galleries, setGallery] = useState([]);


    useEffect(() => {
        const fetchGalleries = async () => {
            const response = await window.apiClient.get(`/data/gallery/5/${currentPage}`);
            setGallery(response.data.data);
            setPagination(response.data.pagination);
        };
        fetchGalleries();
    }, [currentPage])

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return <>
        <section className="read min-h-content" id="about">
            <div className="container px-4 py-8 mx-auto">
                <div className="mb-8 text-center">
                    <h2 className="text-2xl font-bold text-gray-800 uppercase">Galeri</h2>
                    <h3 className="text-gray-500">Galeri OSIS</h3>
                </div>
                {/* Display gallery albums */}
                <div className="grid grid-cols-1 gap-6 md:grid-cols-3" id="listingalbum">
                    {galleries.map((album) => (
                        <Link to={`/gallery/${album.encrypted_id}`} key={album.encrypted_id}>
                            <div className="overflow-hidden rounded-lg border shadow-lg transition-transform hover:scale-105">
                                <img src={`https://admin.sman2amlapura.sch.id/images/album_logo/${album.url_image}`}
                                    alt={album.nama_album}
                                    className="object-cover w-full h-48"
                                />
                                <div className="p-4">
                                    <h4 className="text-lg font-semibold text-gray-700">{album.nama_album}</h4>
                                    <p className="text-sm text-gray-600 line-clamp-2">{album.created_date.substring(0, 10)}</p>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>


                {/* Pagination */}
                <div className="mt-6 konten-pagination">
                    <ul className="flex justify-center space-x-2 text-sm font-medium">
                        {Array.from({ length: pagination.total_pages }, (_, index) => (
                            <li
                                key={index + 1}
                                className={`px-4 py-2 rounded-md cursor-pointer hover:bg-blue-600 ${currentPage === index + 1
                                    ? "text-white bg-blue-500"
                                    : "text-gray-700 bg-gray-300 hover:bg-gray-400"
                                    }`}
                                onClick={() => paginate(index + 1)}
                            >
                                {index + 1}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>

    </>
}

